import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useEstateSettingRoundOptionsSchema = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Forms.errors' })

  const schema = useMemo(
    () =>
      yup
        .object()
        .shape({
          opt_blindRound: yup.boolean().required(t('required')),
          opt_enforceOfferGap: yup.boolean().required(t('required')),
          opt_minOfferGap: yup
            .number()
            .min(0, t('min_number'))
            .when('opt_enforceOfferGap', {
              is: true,
              then: (schema) => schema.required(t('required')),
              otherwise: (schema) => schema.notRequired(),
            }),
        })
        .test(
          'incompatible-options',
          t('incompatibleBlindAndGap'),
          function (values) {
            if (values.opt_blindRound && values.opt_enforceOfferGap) {
              return this.createError({
                path: 'opt_enforceOfferGap',
                message: t('incompatibleBlindAndGap'),
              })
            }
            return true
          }
        ),
    [t]
  )

  return { schema }
}

export type EstateSettingRoundOptionsFormValues = yup.InferType<
  ReturnType<typeof useEstateSettingRoundOptionsSchema>['schema']
>
